export const regExp = {
  phoneFormat: /^(\d{3})-(\d{3})-(\d{4})$/g,
  number2decimals: /(\.\d{2})\d+/g,
  number3Digits: /\B(?=(\d{3})+(?!\d))/g,
  nonDigit: /[^\d.-]/g,
};
